import { render, staticRenderFns } from "./OmsLabel.vue?vue&type=template&id=128793df&scoped=true"
import script from "./OmsLabel.vue?vue&type=script&lang=js"
export * from "./OmsLabel.vue?vue&type=script&lang=js"
import style0 from "./OmsLabel.vue?vue&type=style&index=0&id=128793df&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128793df",
  null
  
)

export default component.exports